import { z } from "zod";
import { extendZodWithOpenApi } from "./extendZod.chunk.mjs";
extendZodWithOpenApi(z);
